import React from 'react';

import Menu from './menu/Menu';
import SearchFiles from './search/SearchFiles';
import Filters from './filters/Filters';

const FileManagerToolbar = () => {
  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-2 col-sm-12 FM-filter">
        <div className="d-flex flex-wrap flex-grow-1 align-items-center justify-content-between filter-wrap p-2 gap-2 my-3">
          <SearchFiles />
          <Filters />
        </div>
        <div className="d-flex align-items-center ms-lg-auto my-2 flex-wrap w-100 gap-2">
          <Menu />
        </div>
      </div>
    </>
  );
};

export default FileManagerToolbar;
